import { render } from "./Assistant.vue?vue&type=template&id=17e22845&scoped=true"
import script from "./Assistant.vue?vue&type=script&lang=js"
export * from "./Assistant.vue?vue&type=script&lang=js"

import "./Assistant.vue?vue&type=style&index=0&id=17e22845&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e22845"]])

export default __exports__